import { LazyLoadUtils } from "../../../utils/index.js";

export const OddsSettingsChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "settings/odds" */
      "./OddsSettings.js"
    ),
  { componentName: "OddsSettings" }
);

export const AppearanceSettingsChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "settings/appearance" */
      "./AppearanceSettings.js"
    ),
  { componentName: "AppearanceSettings" }
);

export const LocalizationSettingsLoaderChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "settings/localization" */
      "./LocalizationSettingsLoader.js"
    ),
  { componentName: "LocalizationSettingsLoader" }
);

export const LanguageSettingsChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "settings/language" */
      "./LanguageSettings.js"
    ),
  { componentName: "LanguageSettings" }
);

export const CountrySettingsChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "settings/country" */
      "./CountrySettings.js"
    ),
  { componentName: "CountrySettings" }
);

export const BiometricsSettingsChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "settings/biometrics" */
      "./BiometricsSettings.js"
    ),
  { componentName: "BiometricsSettings" }
);

export const NotificationsSettingsChunk = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "settings/notifications" */
      "./NotificationsSettings.js"
    ),
  { componentName: "NotificationsSettings" }
);
